module.exports = __webpack_public_path__ + "img/eyes_close.74492224.png";